import { createSlice } from "@reduxjs/toolkit";

// initial form
export const initialFeesForm={
    name:"",
    description:"",
    frequency:"",
    fees_amount:"",
    is_refundable:false,
    late_fees_amount:"",
    late_fees_frequency:"",
    nature:"",
    discount_amount:"",
    percentage:""
}

// initial form
export const initialEditFeesForm={
    name:"",
    description:"",
    frequency:"",
    fees_amount:"",
    is_refundable:false,
    late_fees_amount:"",
    late_fees_frequency:"",
    nature:"",
    discount_amount:"",
}
export const initialEditSubFeesForm={
    name:"",
    fees_amount:"",
    late_fees_amount:"",
    late_fees_frequency:"",
    nature:"",
    discount_amount:"",
    discount_percentage: "",
    sub_component_fee_id: ""
}

const classFees = createSlice({
    name:"classFees",
    initialState:{
        popup:{
            feesPopup:false,
            editFeesPopup:false,
            deleteFeesPopup:false,
            editSubFeesPopup:false,
            deleteSubFeesPopup:false
        },
        form:{
            feesForm:initialFeesForm,
            editFeesForm:initialEditFeesForm,
            editSubFeesForm:initialEditSubFeesForm,
        },
        other:{
            feesInfo:null,
            feesComponent:1,
            editFeesComponent:1,
            subFeesInfo:null
        }
    },
    reducers:{
        // popup reducer action
        openFeesPopup:(state)=>{
            state.popup.feesPopup=true
        },
        closeFeesPopup:(state)=>{
            state.popup.feesPopup=false
        },
        openEditFeesPopup:(state, action)=>{
            state.popup.editFeesPopup=true
            state.form.editFeesForm = action.payload
        },
        closeEditFeesPopup:(state)=>{
            state.popup.editFeesPopup=false
            state.form.editFeesForm = initialEditFeesForm
        },
        openDeleteFeesPopup:(state, action)=>{
            state.popup.deleteFeesPopup=true
            state.other.feesInfo = action.payload
        },
        closeDeleteFeesPopup:(state)=>{
            state.popup.deleteFeesPopup=false
            state.other.feesInfo = null
        },
        openEditSubFessPopup:(state, action)=>{  
            state.popup.editSubFeesPopup=true
            state.form.editSubFeesForm = action.payload
        },
        closeEditSubFeesPopup:(state)=>{
            state.popup.editSubFeesPopup = false
            state.form.editSubFeesForm = initialEditSubFeesForm
        },
        openDeleteSubFeesPopup:(state, action)=>{
            state.popup.deleteSubFeesPopup=true
            state.other.subFeesInfo = action.payload
        },
        closeDeleteSubFeesPopup:(state)=>{
            state.popup.deleteSubFeesPopup=false
            state.other.subFeesInfo = null
        },
        // form reducer
        addFeesForm:(state, action)=>{
            state.form.feesForm=action.payload
        },
        addEditFeesForm:(state, action)=>{
            state.form.editFeesForm=action.payload
        },
        addEditSubFeesForm:(state, action)=>{
            state.form.editSubFeesForm = action.payload
        },
        // other form reducer
        addFeesComponent:(state, action)=>{
            state.other.feesComponent=action.payload
        },
        addEditFeesComponent:(state, action)=>{
            state.other.editFeesComponent=action.payload
        },
    }
})

export default classFees.reducer

export const {openFeesPopup, closeFeesPopup, addFeesForm, openEditFeesPopup,
    closeEditFeesPopup, addEditFeesForm, closeDeleteFeesPopup, openDeleteFeesPopup,
    addFeesComponent, addEditFeesComponent, addEditSubFeesForm, openEditSubFessPopup, closeEditSubFeesPopup, openDeleteSubFeesPopup, closeDeleteSubFeesPopup
}=classFees.actions

// get popup state
export const getFeesPopup = (state) => state.classFees.popup.feesPopup
export const getEditFeesPopup = (state) => state.classFees.popup.editFeesPopup
export const getDeleteFeesPopup = (state) => state.classFees.popup.deleteFeesPopup
export const getEditSubFeesPopup = (state) => state.classFees.popup.editSubFeesPopup
export const getDeleteSubFeesPopup = (state) => state.classFees.popup.deleteSubFeesPopup

// get form state
export const getFeesForm = (state) => state.classFees.form.feesForm
export const getEditFeesForm = (state) => state.classFees.form.editFeesForm
export const getEditSubFeesForm = (state) => state.classFees.form.editSubFeesForm

// other form state
export const getFeesInfo = (state) => state.classFees.other.feesInfo
export const getFeesComponent = (state) => state.classFees.other.feesComponent
export const getEditFeesComponent = (state) => state.classFees.other.editFeesComponent
export const getSubFeesInfo = (state) => state.classFees.other.subFeesInfo
